// extracted by mini-css-extract-plugin
export default {"light":"styles_light__N3fJM","nftCard":"styles_nftCard__tVYAw","imgCard":"styles_imgCard__xZXLw","title":"styles_title__ZxdPY","viewButton":"styles_viewButton__WyHNq"};